import api from './api';

export interface PatientType {
  id: number;
  name: string;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface PatientTypeCreate {
  name: string;
}

export interface PatientTypeUpdate {
  name?: string;
}

const patientTypeService = {
  getAll: async (tenantId: number): Promise<PatientType[]> => {
    const response = await api.get('/patient-types/', { params: { tenant_id: tenantId } });
    return response.data;
  },
  create: async (tenantId: number, data: PatientTypeCreate): Promise<PatientType> => {
    const response = await api.post(`/patient-types/?tenant_id=${tenantId}`, data);
    return response.data;
  },
  update: async (id: number, data: PatientTypeUpdate): Promise<PatientType> => {
    const response = await api.put(`/patient-types/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/patient-types/${id}`);
  },
};

export default patientTypeService;
